<template>
  <v-container>
    <v-data-table
      :headers="headers"
      :items="synergies"
      class="elevation-10 pa-10"
      :search="search"
      :custom-filter="customFilter"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>{{ $t("synergy.title") }}</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-text-field
            v-model="search"
            prepend-icon="mdi-magnify"
            :label="$t('common.search')"
            single-line
            hide-details
          ></v-text-field>
          <v-spacer />
          <v-btn
            v-if="userStore.isWriter()"
            color="primary"
            dark
            class="mb-2 d-none d-sm-flex"
            @click="addItem()"
          >
            {{ $t("synergy.button.add") }}
            <v-icon right dark> mdi-plus-circle</v-icon>
          </v-btn>
          <v-btn
            v-if="userStore.isWriter()"
            color="primary"
            dark
            class="d-flex d-sm-none"
            @click="addItem()"
          >
            <v-icon dark> mdi-plus-circle</v-icon>
          </v-btn>
        </v-toolbar>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-icon small class="mx-2" @click="showItem(item)"> mdi-eye</v-icon>
        <v-icon
          v-if="userStore.isWriter()"
          small
          class="mx-2"
          @click="editItem(item)"
        >
          mdi-pencil</v-icon
        >
        <v-icon
          v-if="userStore.isWriter()"
          small
          class="mx-2"
          @click="deleteItem(item)"
        >
          mdi-delete</v-icon
        >
      </template>
      <template v-slot:[`item.molecules`]="{ item }">
        {{ item.molecules.map((n) => n.name).join(", ") }}
      </template>
    </v-data-table>
    <router-view></router-view>
  </v-container>
</template>

<script>
import router from "@/router";
import { storeToRefs } from "pinia";
import { useSynergyStore } from "@/store/synergyStore";
import { ref } from "vue";
import { useUserStore } from "@/store/userStore";

export default {
  data: function () {
    return {
      store: useSynergyStore(),
      userStore: useUserStore(),
      search: ref(""),
      synergies: null,
      headers: [
        { text: this.$t("synergy.list.header.id"), value: "id" },
        { text: this.$t("synergy.list.header.molecules"), value: "molecules" },
        {
          text: this.$t("synergy.list.header.action"),
          value: "actions",
          sortable: false,
        },
      ],
    };
  },
  beforeMount() {
    this.synergies = storeToRefs(this.store).synergies;
    this.store.getSynergies();
  },
  props: {
    title: String,
  },
  methods: {
    addItem() {
      this.store.$reset();
      router.push({ path: "/synergy/add" });
    },

    showItem(item) {
      this.store.$reset();
      router.push(`synergy/${item.id}`);
    },

    editItem(item) {
      this.store.$reset();
      router.push(`synergy/edit/${item.id}`);
    },

    deleteItem(deleteItem) {
      if (confirm(this.$t("synergy.delete.confirm"))) {
        this.store.deleteSynergy(deleteItem.id);
      }
    },
    customFilter: function (value, search, item) {
      if (!search) return true;
      search = search.toLowerCase();

      // Recursively search all properties
      function recursiveSearch(obj) {
        if (obj && typeof obj === "object") {
          return Object.values(obj).some((val) => recursiveSearch(val));
        }

        if (obj && Array.isArray(obj)) {
          return obj.some((val) => recursiveSearch(val));
        }

        if (
          (obj && typeof obj === "string") ||
          (obj && typeof obj === "number")
        ) {
          return obj.toString().toLowerCase().includes(search);
        }
        return false;
      }

      return recursiveSearch(item);
    },
  },
};
</script>
